export default __webpack_public_path__ + "static/media/IL.15f549e8.svg";